import { expValEquals } from '@atlassian/jira-feature-experiments';
import type { IncidentExperimentTraitsResourceData } from '@atlassian/jira-router-resources-software-incidents/src/services/types.tsx';

export const DUMMY_FLAG_KEY = 'incidents_page_in_jira_-_dummy_experiment';
export const DUMMY_EXPERIMENT_KEY = 'incidents_in_jira_jsm_x_jsw_-_dummy_experiment';
export const PRIMARY_EXPERIMENT_KEY = 'incidents_in_jira_jsm_x_jsw';
export const SECONDARY_EXPERIMENT_KEY = 'incidents_in_jira_jsm_x_jsw_-_secondary_experiment';

export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';

const isPrimaryExperimentEnabled = (isInCohort: boolean) =>
	isInCohort && expValEquals('incidents_in_jira_jsm_x_jsw', 'cohort', 'variation');

const isSecondaryExperimentEnabled = (isInCohort: boolean) =>
	isInCohort &&
	expValEquals('incidents_in_jira_jsm_x_jsw_-_secondary_experiment', 'cohort', 'variation');

const isIncidentsPageEnabled = (incidentExperimentTraits: IncidentExperimentTraitsResourceData) => {
	const featureEnabled =
		isSecondaryExperimentEnabled(incidentExperimentTraits.cohort2) ||
		isPrimaryExperimentEnabled(incidentExperimentTraits.cohort1);

	return featureEnabled;
};

export default isIncidentsPageEnabled;
